import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

//!STYLES
import { Button, Skeleton } from "antd";
import { isToday, StatusCode } from "common/enums";
import st from "./room.module.css";
import s from "./style.module.css";

import { useSelector } from "react-redux";

import { API_RESSOURCES } from "api/services/teacher/teacher.routes";
import axios, { AxiosResponse } from "axios";
import AppResult from "components/appResults";
import moment from "moment";
import Slider from "react-slick";
import CardCreneau from "screens/teacher/calendarTeacher/card";


interface CustomResponse {
    statusCode: number;
    message: string;
    data: any;
}

interface Niche {
    date: string;
    level: {
        _id: string;
        title: string;
        levelGroup: string;
        createdAt: string;
        updatedAt: string;
        __v: number;
    };
    topic: {
        _id: string;
        title: string;
        level: string;
        status: string;
        position: number;
        language: string;
        createdAt: string;
        updatedAt: string;
        __v: number;
        description: string;
        price: string;
    };
    timeRanges: string[];
    idCreneau: string;
    reservations: any[];
    status: any[];
    grouplevels: any[];
    id: number;
    day: string;
}

interface TeacherAvailabilityProps {
    data: any;
    isCollective: boolean;
    setCalendarData: React.Dispatch<any>;
    setLoadingCalendarData: React.Dispatch<boolean>;
    showReserved?: boolean;
}

const TeacherAvailability: React.FC<TeacherAvailabilityProps> = ({ data, isCollective, setCalendarData, setLoadingCalendarData, showReserved }) => {

    // !!HOOKS
    const { id } = useParams();
    const auth = useSelector((state) => state.auth);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);

    /// ********* Calendar Logic ********* ///

    const [creneau, setCreneau] = useState<any>([]);
    const [index, setIndex] = useState<number>(0);
    const [allData, setAllData] = useState<any>([]);
    const [allCreneaux, setAllCreneaux] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingMore, setLoadingMore] = useState<boolean>(true);
    const [isAllData, setIsAllData] = useState<boolean>(true);
    const dateRef = useRef<(HTMLDivElement | null)[]>([]);
    const [confirmReservations, setConfirmRes] = useState<any[]>([]);

    const [creneauCollective, setCollectiveCreneau] = useState<any>([]);
    const [allCollectiveData, setAllCollectiveData] = useState<any>([]);
    const [allCollectiveCreneaux, setAllCollectiveCreneaux] = useState<any>([]);
    const [isAllCollectiveData, setIsAllCollectiveData] = useState<boolean>(true);
    const [confirmCollectiveReservations, setConfirmCollectiveRes] = useState<any[]>([]);

    const [searchStartDate, setSearchStartDate] = useState<any>();
    const [searchEndDate, setSearchEndDate] = useState<any>();

    const formatDate = (date: Date) =>
        date.toISOString().split("T")[0];

    const addDays = (dateStr: string, days: number) => {
        const d = new Date(dateStr);
        d.setDate(d.getDate() + days);
        return formatDate(d);
    };

    const handleAdd30Days = () => {
        const teacherId = auth?.user?._id;
        if (!teacherId) return;

        // First load
        if (!searchStartDate) {
            const startDate = formatDate(new Date());
            const endDate = addDays(startDate, 30);

            setSearchStartDate(startDate);
            setSearchEndDate(endDate);

            fetchCalender(teacherId, startDate, endDate);
            fetchCollectiveCalendar(teacherId, startDate, endDate);
        }
        // Load More
        else {
            const newEndDate = addDays(searchEndDate, 30);

            ///setSearchStartDate(searchStartDate);
            setSearchEndDate(newEndDate);

            fetchMoreCalender(teacherId, searchStartDate, newEndDate);
            fetchMoreCollectiveCalendar(teacherId, searchStartDate, newEndDate);
        }
    };

    const settings = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        className: st.slider,
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
        ],
        afterChange: (current: number) => {
            if (current === allData.length - 3) {
                handleAdd30Days();
            }
        },
    };

    const settingsMobile = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: st.slider,
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
        ],
        afterChange: (current: number) => {
            if (current === allData.length - 1) {
                handleAdd30Days();
            }
        },
    };

    const generateNiches = useCallback(
        (data: any) => {
            const niches = [];
            if (Array.isArray(data?.niches) && data?.niches?.length > 0) {
                const topics = Array.isArray(data?.niches[0]?.topic)
                    ? data?.niches[0]?.topic
                    : [];
                const levels = Array.isArray(data?.niches[0]?.level)
                    ? data?.niches[0]?.level
                    : [];
                const topicsLength = topics?.length;
                const levelsLength = levels?.length;

                for (let i = 0; i < topicsLength; i++) {
                    for (let j = 0; j < levelsLength; j++) {
                        const filteredTopics = data?.niches?.map((n: any) =>
                            Array.isArray(n.topic) && Array.isArray(n?.level)
                                ? n?.topic.filter(
                                    (t: any) =>
                                        t?.level === n?.level[j]._id && t?.position === i + 1
                                )
                                : []
                        );

                        const foundTopic = filteredTopics?.find((n: any) => n?.length > 0);

                        if (foundTopic) {
                            const niche = {
                                date: data.niches[0].date,
                                level: data.niches[0].level[j],
                                topic: foundTopic[j],
                                timeRanges: data.niches[0].timeRanges[j],
                                idCreneau: data.niches[0].idCreneau,
                                reservations:
                                    data.niches[0] && data.niches[0].reservations
                                        ? data.niches[0].reservations[j] || []
                                        : [],
                                status: data.niches[0].status[j] || [],
                                annonce: data.annonce,
                                id: j + 1,
                                creneauTypes: data.niches[0].creneauTypes[j] || [],
                                grouplevels: data.niches[0].grouplevels[j] || "",
                                day: data.day,
                                classeId: data.niches[0].classeId || "",
                            };
                            niches.push(niche);
                        }
                    }
                }
            }
            const output = { day: data.day, niches: niches };
            setCreneau(output);
            return output;
        },
        [creneau]
    );

    const generateCollectiveNiches = useCallback(
        (data: any) => {
            const niches = [];
            if (Array.isArray(data?.niches) && data?.niches?.length > 0) {
                const topics = Array.isArray(data?.niches[0]?.topic)
                    ? data?.niches[0]?.topic
                    : [];
                const levels = Array.isArray(data?.niches[0]?.level)
                    ? data?.niches[0]?.level
                    : [];
                const topicsLength = topics?.length;
                const levelsLength = levels?.length;

                for (let i = 0; i < topicsLength; i++) {
                    for (let j = 0; j < levelsLength; j++) {
                        const filteredTopics = data?.niches?.map((n: any) =>
                            Array.isArray(n.topic) && Array.isArray(n?.level)
                                ? n?.topic.filter(
                                    (t: any) =>
                                        t?.level === n?.level[j]._id && t?.position === i + 1
                                )
                                : []
                        );

                        const foundTopic = filteredTopics?.find((n: any) => n?.length > 0);

                        if (foundTopic) {
                            const niche = {
                                date: data.niches[0].date,
                                level: data.niches[0].level[j],
                                topic: foundTopic[j],
                                timeRanges: data.niches[0].timeRanges[j],
                                idCreneau: data.niches[0].idCreneau,
                                reservations:
                                    data.niches[0] && data.niches[0].reservations
                                        ? data.niches[0].reservations[j] || []
                                        : [],
                                status: data.niches[0].status[j] || [],
                                annonce: data.annonce,
                                id: j + 1,
                                creneauTypes: data.niches[0].creneauTypes[j] || [],
                                grouplevels: data.niches[0].grouplevels[j] || "",
                                day: data.day,
                                classeId: data.niches[0].classeId || "",
                            };
                            niches.push(niche);
                        }
                    }
                }
            }
            const output = { day: data.day, niches: niches };
            setCollectiveCreneau(output);
            return output;
        },
        [creneau]
    );

    const fetchCalender = useCallback(
        async (idTeacher: string, startDate: string, endDate: string) => {
            setLoading(true);
            if (auth?.user?._id) {
                try {
                    ///const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${idTeacher}?typeCreneaux=all`,
                    const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${idTeacher}?isCollective=true`,
                        {
                            params: { startDate, endDate },
                            headers: {
                                "Cache-Control": "no-cache",
                                Pragma: "no-cache",
                                Expires: "0",
                            },
                        }
                    );

                    if (response.status === StatusCode.OK) {
                        if (response?.data?.data) {

                            // Keep old data + append new
                            setAllData((prev: any[]) => {
                                const merged = [...response.data?.data, ...prev];

                                // Remove duplicates by day
                                const unique = merged.filter(
                                    (item, index, self) =>
                                        index === self.findIndex((t) => t.day === item.day)
                                );

                                // Sort by date (ascending)
                                return unique.sort(
                                    (a, b) => new Date(a.day).getTime() - new Date(b.day).getTime()
                                );
                            });

                            const result = response.data?.data
                                .filter((data: any) => data?.niches?.length > 0)
                                .map((niche: any) => generateNiches(niche));

                            setAllCreneaux((prev: any[]) => {
                                if (prev.length === 0) {
                                    // First call → just set
                                    return result;
                                }
                                // Next calls → append
                                return [...prev, ...result];
                            });
                        }
                        else {
                            setAllData([]);
                            setAllCreneaux([]);
                            setCreneau([]);
                        }
                    }
                    else {
                        setAllData([]);
                        setAllCreneaux([]);
                        setCreneau([]);
                    }
                } catch (error) {
                    setAllData([]);
                    setAllCreneaux([]);
                    setCreneau([]);
                } finally {
                    setLoading(false);
                    setLoadingMore(false);
                    setSearchStartDate(endDate);
                }
            }
        },
        [auth?.user?._id]
    );

    const fetchCollectiveCalendar = useCallback(
        async (idTeacher: string, startDate: string, endDate: string) => {
            setLoading(true);
            if (auth?.user?._id) {
                try {
                    const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${idTeacher}?isCollective=true&classeId=${data?._id}`,
                        {
                            params: { startDate, endDate },
                            headers: {
                                "Cache-Control": "no-cache",
                                Pragma: "no-cache",
                                Expires: "0",
                            },
                        }
                    );

                    if (response.status === StatusCode.OK) {
                        if (response?.data?.data) {

                            // Keep old data + append new
                            setAllCollectiveData((prev: any[]) => {
                                const merged = [...response.data?.data, ...prev];

                                // Remove duplicates by day
                                const unique = merged.filter(
                                    (item, index, self) =>
                                        index === self.findIndex((t) => t.day === item.day)
                                );

                                // Sort by date (ascending)
                                return unique.sort(
                                    (a, b) => new Date(a.day).getTime() - new Date(b.day).getTime()
                                );
                            });

                            const result = response.data?.data
                                .filter((data: any) => data?.niches?.length > 0)
                                .map((niche: any) => generateCollectiveNiches(niche));

                            setAllCollectiveCreneaux((prev: any[]) => {
                                if (prev.length === 0) {
                                    // First call → just set
                                    return result;
                                }
                                // Next calls → append
                                return [...prev, ...result];
                            });
                        }
                        else {
                            setAllCollectiveData([]);
                            setAllCollectiveCreneaux([]);
                            setCollectiveCreneau([]);
                        }
                    }
                    else {
                        setAllCollectiveData([]);
                        setAllCollectiveCreneaux([]);
                        setCollectiveCreneau([]);
                    }
                } catch (error) {
                    setAllCollectiveData([]);
                    setAllCollectiveCreneaux([]);
                    setCollectiveCreneau([]);
                } finally {
                    setLoading(false);
                    setLoadingMore(false);
                    setSearchStartDate(endDate);
                }
            }
        },
        [auth?.user?._id]
    );

    const fetchMoreCalender = async (idTeacher: string, startDate: string, endDate: string) => {
        setLoadingMore(true);
        if (auth?.user?._id) {
            try {
                ///const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${idTeacher}?typeCreneaux=all`,
                const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${idTeacher}?isCollective=true`,
                    {
                        params: { startDate, endDate },
                        headers: {
                            "Cache-Control": "no-cache",
                            Pragma: "no-cache",
                            Expires: "0",
                        },
                    }
                );

                if (response.status === StatusCode.OK) {
                    if (response?.data?.data) {

                        // Keep old data + append new
                        setAllData((prev: any[]) => {
                            const merged = [...response.data?.data, ...prev];

                            // Remove duplicates by day
                            const unique = merged.filter(
                                (item, index, self) =>
                                    index === self.findIndex((t) => t.day === item.day)
                            );

                            // Sort by date (ascending)
                            return unique.sort(
                                (a, b) => new Date(a.day).getTime() - new Date(b.day).getTime()
                            );
                        });

                        const result = response.data?.data
                            .filter((data: any) => data?.niches?.length > 0)
                            .map((niche: any) => generateNiches(niche));

                        setAllCreneaux((prev: any[]) => {
                            if (prev.length === 0) {
                                // First call → just set
                                return result;
                            }
                            // Next calls → append
                            return [...prev, ...result];
                        });
                    }
                    else {
                        setAllData([]);
                        setAllCreneaux([]);
                        setCreneau([]);
                    }
                }
                else {
                    setAllData([]);
                    setAllCreneaux([]);
                    setCreneau([]);
                }
            } catch (error) {
                setAllData([]);
                setAllCreneaux([]);
                setCreneau([]);
            } finally {
                setLoadingMore(false);
                setSearchStartDate(endDate);
            }
        }
    };

    const fetchMoreCollectiveCalendar = async (idTeacher: string, startDate: string, endDate: string) => {
        setLoadingMore(true);
        if (auth?.user?._id) {
            try {
                const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${idTeacher}?isCollective=true&classeId=${data?._id}`,
                    {
                        params: { startDate, endDate },
                        headers: {
                            "Cache-Control": "no-cache",
                            Pragma: "no-cache",
                            Expires: "0",
                        },
                    }
                );

                if (response.status === StatusCode.OK) {
                    if (response?.data?.data) {

                        // Keep old data + append new
                        setAllCollectiveData((prev: any[]) => {
                            const merged = [...response.data?.data, ...prev];

                            // Remove duplicates by day
                            const unique = merged.filter(
                                (item, index, self) =>
                                    index === self.findIndex((t) => t.day === item.day)
                            );

                            // Sort by date (ascending)
                            return unique.sort(
                                (a, b) => new Date(a.day).getTime() - new Date(b.day).getTime()
                            );
                        });

                        const result = response.data?.data
                            .filter((data: any) => data?.niches?.length > 0)
                            .map((niche: any) => generateCollectiveNiches(niche));

                        setAllCollectiveCreneaux((prev: any[]) => {
                            if (prev.length === 0) {
                                // First call → just set
                                return result;
                            }
                            // Next calls → append
                            return [...prev, ...result];
                        });
                    }
                    else {
                        setAllCollectiveData([]);
                        setAllCollectiveCreneaux([]);
                        setCollectiveCreneau([]);
                    }
                }
                else {
                    setAllCollectiveData([]);
                    setAllCollectiveCreneaux([]);
                    setCollectiveCreneau([]);
                }
            } catch (error) {
                setAllCollectiveData([]);
                setAllCollectiveCreneaux([]);
                setCollectiveCreneau([]);
            } finally {
                setLoadingMore(false);
                setSearchStartDate(endDate);
            }
        }
    };

    useEffect(() => {
        if (auth?.user) {
            handleAdd30Days();
        }
    }, [auth]);

    useEffect(() => {
        if (allCreneaux && allCreneaux?.length > 0) {
            setCalendarData(allCreneaux);
            setLoadingCalendarData(false);
        }
    }, [allCreneaux]);

    /// ********* Calendar Logic ********* ///

    return (
        <>
            {allCollectiveData?.length > 0 && <div className={s.weekBox}>
                <div style={{ width: "5%" }}>
                    <Button
                        onClick={() => {
                            setConfirmCollectiveRes([]);
                            setIsAllCollectiveData(true);
                        }}
                        style={{ height: isMobile ? "25px" : "35px", backgroundColor: isAllData ? "var(--first-color)" : "transparent", color: isAllData ? "#fff" : "#333", borderRadius: isMobile ? "12px" : "16px", fontSize: isMobile ? "0.8em" : "14px", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        Afficher tout
                    </Button>
                </div>
                <div style={{ width: isMobile ? "50%" : "78%", marginRight: isMobile ? "25px" : "20px" }}>
                    {!isMobile && <Slider {...settings}>
                        {allCollectiveData?.map((item: any, index: number) => (
                            <div
                                key={index}
                                ref={(el) => (dateRef.current[index] = el)}
                                onClick={() => {
                                    generateCollectiveNiches(item);
                                    setConfirmCollectiveRes([]);
                                    setIndex(index);
                                    setIsAllCollectiveData(false);
                                }}
                                className={`${s.date} ${creneauCollective?.day === item?.day && s.active}`}
                            >
                                <span>{moment(item?.day).format('dddd D MMMM YYYY')}</span>
                            </div>
                        ))}
                    </Slider>}
                    {isMobile && <Slider {...settingsMobile}>
                        {allCollectiveData?.map((item: any, index: number) => (
                            <div
                                key={index}
                                ref={(el) => (dateRef.current[index] = el)}
                                onClick={() => {
                                    generateCollectiveNiches(item);
                                    setConfirmCollectiveRes([]);
                                    setIndex(index);
                                    setIsAllCollectiveData(false);
                                }}
                                className={`${s.date} ${creneauCollective?.day === item?.day && s.active}`}
                            >
                                <span>{moment(item?.day).format('dddd D MMMM YYYY')}</span>
                            </div>
                        ))}
                    </Slider>}
                </div>
            </div>}

            {
                loading ? (
                    <>
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                    </>
                ) : (
                    <Fragment>
                        {!loading && allCollectiveData?.length > 0 ? (
                            <div className={s.calendarBox}>
                                {isAllCollectiveData ? (
                                    allCollectiveCreneaux?.map((cren: any, index: number) => {
                                        return (
                                            cren?.niches[0]?.idCreneau !== undefined && <div key={index} style={{ marginBottom: "20px" }}>
                                                <div className={s.dateBox}>
                                                    {new Intl.DateTimeFormat("fr-FR", {
                                                        weekday: "long",
                                                        day: "numeric",
                                                        month: "long",
                                                        year: "numeric",
                                                    }).format(new Date(cren?.day))}
                                                    {isToday(cren?.day) && <div className={s.todayBox}>Aujourd’hui</div>}
                                                    <div className={s.horizontalLine}></div>
                                                </div>

                                                {isMobile && <div className={s.cardTime}>
                                                    {cren?.niches?.map((c: any, index: number) => {
                                                        return (
                                                            <CardCreneau
                                                                isAllReservation={false}
                                                                key={index}
                                                                cren={c}
                                                                index={index}
                                                                currentTeacher={data?.teacher}
                                                                confirmReservations={confirmCollectiveReservations}
                                                                setConfirmRes={setConfirmCollectiveRes}
                                                                showReserved={showReserved}
                                                            />
                                                        );
                                                    })}
                                                </div>}
                                                {!isMobile && cren?.niches?.map((c: any, index: number) => {
                                                    return (
                                                        <CardCreneau
                                                            isAllReservation={false}
                                                            key={index}
                                                            cren={c}
                                                            index={index}
                                                            currentTeacher={data?.teacher}
                                                            confirmReservations={confirmCollectiveReservations}
                                                            setConfirmRes={setConfirmCollectiveRes}
                                                            showReserved={showReserved}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )
                                    })
                                ) : (
                                    <div>
                                        <div className={s.dateBox}>
                                            {new Intl.DateTimeFormat("fr-FR", {
                                                weekday: "long",
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric",
                                            }).format(new Date(creneauCollective?.day))}
                                            {isToday(creneauCollective?.day) && <div className={s.todayBox}>Aujourd’hui</div>}
                                            <div className={s.horizontalLine}></div>
                                        </div>

                                        {creneauCollective?.niches?.length <= 0 ? (
                                            <AppResult
                                                status="info"
                                                title={`Tu n'as aucune disponibilité pour le ${moment(
                                                    creneauCollective?.day
                                                ).format("LL")}`}
                                            />
                                        ) : (
                                            <Fragment>
                                                {isMobile && <div className={s.cardTime}>
                                                    {creneauCollective?.niches?.map((cren: any, index: number) => {
                                                        return (
                                                            <CardCreneau
                                                                key={index}
                                                                cren={cren}
                                                                index={index}
                                                                isAllReservation={false}
                                                                currentTeacher={data?.teacher}
                                                                confirmReservations={confirmCollectiveReservations}
                                                                setConfirmRes={setConfirmCollectiveRes}
                                                                showReserved={showReserved}
                                                            />
                                                        );
                                                    })}
                                                </div>}
                                                {!isMobile && creneauCollective?.niches?.map((cren: any, index: number) => {
                                                    return (
                                                        <CardCreneau
                                                            key={index}
                                                            cren={cren}
                                                            index={index}
                                                            isAllReservation={false}
                                                            currentTeacher={data?.teacher}
                                                            confirmReservations={confirmCollectiveReservations}
                                                            setConfirmRes={setConfirmCollectiveRes}
                                                            showReserved={showReserved}
                                                        />
                                                    );
                                                })}
                                            </Fragment>
                                        )}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <AppResult
                                status={"info"}
                                title="Tu n'as aucune disponibilité"
                                isMobile={isMobile ? true : false}
                            />
                        )}
                    </Fragment>
                )
            }
        </>
    );
}

export default TeacherAvailability;